import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/panel.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../../packages/props-utils/prop-types.js';
import { requiredChildrenValidation } from '../../../prop-types-validators/children-validator.js';
import { PANEL_FOOTER_JUSTIFY } from './types.js';

const bemPanel = new HoneyBem('panel', styles);
function PanelFooter(_a) {
  var {
      children,
      justify,
      extraClasses
    } = _a,
    rest = __rest(_a, ["children", "justify", "extraClasses"]);
  const justifyValue = justify && "justify-".concat(justify);
  const [column1, column2] = React.Children.toArray(children);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: bemPanel.e('footer', justifyValue, extraClasses)
  }, rest), column1, column2);
}
PanelFooter.displayName = 'PanelFooter';
PanelFooter.propTypes = {
  extraClasses: PropTypes.string,
  justify: PropTypes.oneOf(PANEL_FOOTER_JUSTIFY),
  children: requiredChildrenValidation('PanelFooterColumn')
};

export { PanelFooter as default };
